import { Component, OnInit, AfterViewInit, OnDestroy, Input, ElementRef, ViewChild, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { CalendarMonthViewDay, CalendarView } from 'angular-calendar';
import { GenericService } from 'app/services/generic/generic.service';
import { AuthService } from 'app/services/auth/auth.service';
import { FunctionsControllerService } from 'app/services/generic/functions-controller.service';
import { FunctionsService } from 'app/services/generic/functions.service';

import {
  Overlay,
  OverlayRef,
  OverlayPositionBuilder
} from '@angular/cdk/overlay';
import {
  TemplatePortal
} from '@angular/cdk/portal';

@Component({
  selector: 'app-table-agenda',
  templateUrl: './table-agenda.component.html',
  styleUrls: ['./table-agenda.component.scss']
})
export class TableAgendaComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() structure = null;
  @Input() index: number;
  @Input() indexTable: number;
  @Input() group: any;
  @Input() oldBdField: any;
  @Input() oldValue: any;
  @Input() tab: any;
  @Input() idFa: any;
  @ViewChild('customEventTooltip') customEventTooltip!: TemplateRef<any>;
  private overlayRef: OverlayRef | null = null;  tooltipEventData: any = null;
  loaded = false;
  columnOnClick = null;

  public daysOfWeek = [
    { label: 'Lunes',      value: 1 },
    { label: 'Martes',     value: 2 },
    { label: 'Miércoles',  value: 3 },
    { label: 'Jueves',     value: 4 },
    { label: 'Viernes',    value: 5 },
    { label: 'Sábado',     value: 6 },
    { label: 'Domingo',    value: 0 }
  ];

   // Estas son las vistas disponibles en el calendario
   CalendarView = CalendarView;
  
   // Esta variable define cuál vista se está mostrando (Month, Week, Day)
   view: CalendarView = CalendarView.Week;
 
   // Define la fecha base para la vista
   viewDate: Date = new Date();
 
   // Activa / desactiva panel de eventos en modo mes
   activeDayIsOpen: boolean = true;
 
   // Control de eventos (por ejemplo, para refrescar la vista)
   refresh: Subject<any> = new Subject();
 
   // Idioma y configuración de inicio de semana, fin de semana, etc.
   locale: string = 'es';
   weekStartsOn: number = 1;  // 0 = Domingo, 1 = Lunes, etc.
   weekendDays: number[] = [0, 6]; // Define qué días son fin de semana
   dayStartHour: number = 7;  // Hora de inicio para la vista de día/semana
   dayEndHour: number = 20;   // Hora de fin para la vista de día/semana
   hourSegments: number = 1;  // Por ejemplo, para dividir la hora en 30 min
   hourSegmentHeight: number = 70; // Ajusta el alto de cada segmento
   
  labelInitial = '';
  labelFinal = '';  
  labelTittle = '';
  minMins = 5; // Mínimo de minutos para eventos
  primaryColor = this.authService.primary_color; // Color primario para eventos
  secondaryColor = this.authService.secondary_color; // Color secundario para eventos

   eventsWithNoDate = [];
 
   // Aquí guardamos los eventos
   customEvents = [];
   displayedColumnsMap : { [key: string]: boolean } = {};

   showHeights = false;
   showNoDate = false;

   idFADateInitial = null;
   actual_id_functional_area;

   @ViewChild('calendarContainer') calendarContainer!: ElementRef;
   calendarHeight: number = 400; // valor por defecto inicial

  constructor(public authService: AuthService, public genericService: GenericService, private functionsControllerService: FunctionsControllerService, private functionsService: FunctionsService,
    private overlay: Overlay,
    private overlayPositionBuilder: OverlayPositionBuilder,
    private vcr: ViewContainerRef,
  ) { }

  ngOnInit(): void {

    // 0) Reiniciamos los arrays para que no quede basura de ejecuciones anteriores
    this.customEvents = [];
    this.eventsWithNoDate = [];
    this.actual_id_functional_area = this.genericService.getActualInitialFA(this.structure[this.index]);
  
    console.log('TableAgendaComponent', this.tab);
    // 1) Lectura de parámetros de tu tab (sin tocar)
    if (this.tab['min_slot_per_event']) {
      this.minMins = this.tab['min_slot_per_event'];
    }
    if (this.tab['primary_color']) {
      this.primaryColor = this.tab['primary_color'];
    }
    if (this.tab['secondary_color']) {
      this.secondaryColor = this.tab['secondary_color'];
    }
  
    if (this.tab['id_functional_area_date_initial']) {
      this.idFADateInitial = this.genericService.findElementWithId(
        this.tab['id_functional_area_date_initial'],
        false, true, true
      );
      if (this.idFADateInitial) {
        this.labelInitial = this.idFADateInitial['id_functional_area']
          + '-' + this.idFADateInitial['bd_field'];
      }
    }
  
    if (this.tab['id_functional_area_date_end']) {
      const idFADateFinal = this.genericService.findElementWithId(
        this.tab['id_functional_area_date_end'],
        false, true, true
      );
      if (idFADateFinal) {
        this.labelFinal = idFADateFinal['id_functional_area']
          + '-' + idFADateFinal['bd_field'];
      }
    }
  
    if (this.tab['id_functional_area_title']) {
      const idFATitle = this.genericService.findElementWithId(
        this.tab['id_functional_area_title'],
        false, true, true
      );
      if (idFATitle) {
        const bdFieldRaw: string = idFATitle['bd_field'] || '';
        const bdFieldFirst = bdFieldRaw.split(',')[0].trim();
        this.labelTittle = `${idFATitle['id_functional_area']}-${bdFieldFirst}`;
      }
    }
  
    // 2) Clonamos los datos de la tabla
    const events = this.genericService.cloneVariable(
      this.genericService.tablesInformation[
        this.structure[this.index]['id_functional_area']
      ].dataSourceTables[this.indexTable]['filteredData']
    );
  
    // 3) Buscamos la columna al hacer click (igual que antes)
    for (let c in this.structure[this.index]['child']) {
      if (this.structure[this.index]['child'][c]['id_function'] > 0) {
        this.columnOnClick = this.structure[this.index]['child'][c];
        break;
      }
    }
  
    // 4) Procesamiento: EXACTAMENTE tu forEach original
    events.forEach(item => {
      const fechaStringInicio = item[this.labelInitial] || '';
    
      // -- Si no tiene fecha de inicio, lo guardo en eventsWithNoDate y salgo --
      if (!fechaStringInicio.trim()) {
        this.eventsWithNoDate.push({data:item});
        return;
      }
    
      // -- Detecto si viene solo fecha (sin hora) --
      const partsIni = fechaStringInicio.split(' ');
      const datePartIni = partsIni[0];
      const timePartIni = partsIni[1];  // undefined si no venía hora
      const [dayIni, monthIni, yearIni] = datePartIni.split('-').map(Number);
    
      let fechaInicio: Date;
      let isAllDay = false;
    
      if (!timePartIni) {
        // —> Caso “all-day”
        isAllDay = true;
        fechaInicio = new Date(yearIni, monthIni - 1, dayIni);
      } else {
        // —> Caso “con hora”
        const [hourIni, minuteIni] = timePartIni.split(':').map(Number);
        fechaInicio = new Date(yearIni, monthIni - 1, dayIni, hourIni, minuteIni);
      }
    
      // -- Fecha fin: similar detección de all-day o con hora --
      let fechaFin: Date;
      const fechaStringFin = item[this.labelFinal] || '';
      if (fechaStringFin.trim()) {
        const partsFin = fechaStringFin.split(' ');
        const [dayFin, monthFin, yearFin] = partsFin[0].split('-').map(Number);
        const timePartFin = partsFin[1];
        if (!timePartFin) {
          // all-day hasta día siguiente
          fechaFin = new Date(yearFin, monthFin - 1, dayFin + 1);
        } else {
          const [hourFin, minuteFin] = timePartFin.split(':').map(Number);
          fechaFin = new Date(yearFin, monthFin - 1, dayFin, hourFin, minuteFin);
        }
      } else {
        // no trae fin: si es all-day, +1 día, si no, 
        fechaFin = isAllDay
          ? new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), fechaInicio.getDate() + 1)
          : new Date(fechaInicio.getTime() + this.minMins * 60000);
      }
    
      // -- Empujo el evento al customEvents, incluyendo allDay --
      this.customEvents.push({
        start:   fechaInicio,
        end:     fechaFin,
        title:   item[this.labelTittle] || item['tittle'] || 'Sin título',
        color:   {
          primary:   this.primaryColor,
          secondary: this.secondaryColor
        },
        allDay:  isAllDay,
        data:    item
      });
    });
  
    // 5) Marcar que ya cargó todo
    setTimeout(() => {
      if(this.genericService.paramControlVariablesFAs[this.actual_id_functional_area] && this.genericService.paramControlVariablesFAs[this.actual_id_functional_area][this.genericService.paramControlVariables[this.actual_id_functional_area]['indexParam']] && this.genericService.paramControlVariablesFAs[this.actual_id_functional_area][this.genericService.paramControlVariables[this.actual_id_functional_area]['indexParam']][this.idFa]['agendaView'] && this.genericService.paramControlVariablesFAs[this.actual_id_functional_area][this.genericService.paramControlVariables[this.actual_id_functional_area]['indexParam']][this.idFa]['agendaView'][this.tab['id_display']]) {
        // Si ya hay un filtro guardado, lo aplicamos
        const savedFilter = this.genericService.paramControlVariablesFAs[this.actual_id_functional_area][this.genericService.paramControlVariables[this.actual_id_functional_area]['indexParam']][this.idFa]['agendaView'][this.tab['id_display']];
        this.view = savedFilter.view || CalendarView.Week;
        this.showNoDate = savedFilter.showNoDate || false;
        this.weekStartsOn = savedFilter.weekStartsOn || 1;
        this.dayStartHour = savedFilter.dayStartHour || 7;
        this.dayEndHour = savedFilter.dayEndHour || 20;
        this.hourSegments = savedFilter.hourSegments || 1;
        this.hourSegmentHeight = savedFilter.hourSegmentHeight || 70;
      }

      this.structure[this.index]['displayedColumns'].forEach(key => {
        this.displayedColumnsMap[key] = true;
      });

      this.loaded = true;
    });
  }

  loadDataField(event: any): any {
    if(!event.dataLoadingTreat) {
      console.log('Cargando data field:', event);
      let dataLoaded = [];
      event.dataLoadingTreat = true;
      let data = event.data;
      for(let i in data) {
        if(data[i] === undefined || data[i] === null || data[i] == "" || data[i] == " ") continue;
        if (i === '0000-selectorCheckbox' || !i.includes('-')) continue;
        if(this.displayedColumnsMap[i] != undefined) { // Existe la columna en la table
          const idFaSplited = i.split('-');
          // Aquí haces lo que necesites con idFaSplited
          if(idFaSplited[1]) {
            let idFa = this.genericService.findElementWithId(idFaSplited[0], false, false, true);
            if(idFa) {
              if(idFa['type'] && idFa['type'] =="image") console.log('Image found:', data[i]);
              dataLoaded.push({
                label: idFa['label'] && idFa['label'] != "" && idFa['label'] != " " ? idFa['label'] + ": " : null,
                value: data[i],
                type: idFa['type'],
                class_custom: idFa['class_custom'],
                style: idFa['styleParsed']['style'],
                icon: idFa['icon'] ? idFa['icon'] : null
              });
            }
          }
        }
      }
      event.dataLoaded = dataLoaded;
      console.log('Data loaded:', dataLoaded);
    }
    return false;
  }

  ngAfterViewInit(): void {
    this.setCalendarHeight();
  
    // Escuchamos cambios de tamaño para recalcular
    window.addEventListener('resize', this.setCalendarHeight.bind(this));
  }
  
  setCalendarHeight(): void {
    if (this.calendarContainer && this.calendarContainer.nativeElement) {
      this.calendarHeight = this.calendarContainer.nativeElement.offsetHeight;
    }
  }
  
  // Si quieres manejar el clic en un día, por ejemplo, en la vista de mes:
  dayClicked(day: CalendarMonthViewDay): void {
    // Podrías, por ejemplo, togglear el panel de eventos del día
    if (day.events.length > 0 || !this.activeDayIsOpen) {
      this.activeDayIsOpen = !this.activeDayIsOpen;
    }
  }

  // Cuando se hace clic en un evento
  handleEvent(action: string, event: any): void {
    switch (action) {
      case 'Clicked':
        this.onClickEditActivity(event);
        break;
      case 'HourClicked':
        this.onClickAddActivity(event);
        break;
      case 'Dropped or resized':
        // this.refresh.next();
        break;
    }
  }

  // Cuando se arrastra o se cambia la duración de un evento
  eventTimesChanged(evento: any): void {
    // Lógica para cambiar hora de inicio/fin del evento
    // evento.event = el evento que se ha movido
    // evento.newStart / evento.newEnd = nuevas fechas de inicio/fin
    console.log('Evento arrastrado / cambiado: ', evento);
  }

  // Ejemplos de hooks para manipular vista mes/semana/día antes de renderizar
  beforeMonthViewRender(evento: any): void {
    console.log('Mes: antes de renderizar', evento);
  }
  beforeMonthViewRenderWeek(evento: any): void {
    console.log('Semana: antes de renderizar', evento);
  }
  beforeMonthViewRenderDay(evento: any): void {
    console.log('Día: antes de renderizar', evento);
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  onHourSegmentHeightChange(newValue: number): void {
    this.saveFilter();
  }

  onHourSegmentsChange(newValue: number): void {
    this.saveFilter();
  }
  
  onClickEditActivity(event: any) {
    // this.structure[this.index]['isPressingControl'] = event !== undefined && (event.sourceEvent.ctrlKey || event.sourceEvent.metaKey);
    this.functionsControllerService.getFunction(this.structure[this.index], event.event.data);
  }

  onClickAddActivity(event: any) {
    console.log('Añadir actividad:', event, this.columnOnClick, this.functionsService.formatDate(event['date'], true));
    if(this.columnOnClick) {
      let value = this.functionsService.formatDate(event['date']);
      if (this.idFADateInitial && this.idFADateInitial['bd_table'] && this.idFADateInitial['bd_field']) {
        this.functionsService.addWindowParam(value, this.idFADateInitial['id_db'], this.idFADateInitial['bd_table'], this.idFADateInitial['bd_field'], this.structure[this.index]['id_functional_parent_initial']); // Hay que poner en el header porque el Dialog esta en el Header --> Como hacemos esto dinámico???
        this.functionsService.addWindowParam(value, this.idFADateInitial['id_db'], this.idFADateInitial['bd_table'], this.idFADateInitial['bd_field'], this.structure[this.index]['id_functional_parent_initial'], false, "output"); // Hay que poner en el header porque el Dialog esta en el Header --> Como hacemos esto dinámico???
        this.columnOnClick['refresh_params'] = 2; // --> No hace caso y no lo pasa
        this.columnOnClick["paramsAdded"] = true;
        // this.columnOnClick['isPressingControl'] = event !== undefined && (event.sourceEvent.ctrlKey || event.sourceEvent.metaKey);
        if(this.columnOnClick['id_function']) {
          if(this.columnOnClick['id_function'] == 2) this.columnOnClick['id_function'] = 35;
          if(this.columnOnClick['id_function'] == 45) this.columnOnClick['id_function'] = 46;
        }
      }
      this.functionsControllerService.getFunction(this.columnOnClick);
    }
  }

  /**
   * Salta directamente al día de hoy en el calendario.
   */
  public goToToday(): void {
    // Pon la fecha de vista en hoy
    this.viewDate = new Date();
    // Si tienes abierto el “día” dentro de la vista de mes, ciérralo
    this.closeOpenMonthViewDay();
    this.saveFilter();
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.setCalendarHeight.bind(this));
  }

  saveFilter() {
    setTimeout(() => {
      console.log('saveFilter', this.tab);
      if(this.authService.userId > 0 && !(this.structure[this.index]['id_functional_parent_initial_dsb'] > 0)) {
        if(this.genericService.paramControlVariablesFAs[this.actual_id_functional_area][this.genericService.paramControlVariables[this.actual_id_functional_area]['indexParam']][this.idFa] === undefined) this.genericService.paramControlVariablesFAs[this.actual_id_functional_area][this.genericService.paramControlVariables[this.actual_id_functional_area]['indexParam']][this.idFa] = {};
        let obj = {
          view: this.view,
          showNoDate: this.showNoDate,
          weekStartsOn: this.weekStartsOn,
          dayStartHour: this.dayStartHour,
          dayEndHour: this.dayEndHour,
          hourSegments: this.hourSegments,
          hourSegmentHeight: this.hourSegmentHeight
        }
        if(!this.genericService.paramControlVariablesFAs[this.actual_id_functional_area][this.genericService.paramControlVariables[this.actual_id_functional_area]['indexParam']][this.idFa]['agendaView']) this.genericService.paramControlVariablesFAs[this.actual_id_functional_area][this.genericService.paramControlVariables[this.actual_id_functional_area]['indexParam']][this.idFa]['agendaView'] = {};
        if(!this.genericService.paramControlVariablesFAs[this.actual_id_functional_area][this.genericService.paramControlVariables[this.actual_id_functional_area]['indexParam']][this.idFa]['agendaView'][this.tab['id_display']]) this.genericService.paramControlVariablesFAs[this.actual_id_functional_area][this.genericService.paramControlVariables[this.actual_id_functional_area]['indexParam']][this.idFa]['agendaView'][this.tab['id_display']] = {};
        // Guardamos el objeto de configuración en paramControlVariablesFAs
        this.genericService.paramControlVariablesFAs[this.actual_id_functional_area][this.genericService.paramControlVariables[this.actual_id_functional_area]['indexParam']][this.idFa]['agendaView'][this.tab['id_display']] = obj;
        this.genericService.updateParamControlFA(this.idFa, this.actual_id_functional_area, this.genericService.paramControlVariables[this.actual_id_functional_area]['indexParam']);
      }
    });
  }

  onDayEndHourChange(newValue: number): void {
    this.dayEndHour = newValue;
    this.saveFilter();
  }
  onDayStartHourChange(newValue: number): void {
    this.dayStartHour = newValue;
    this.saveFilter();
  }
  onWeekStartsOnChange(newValue: number): void {
    this.weekStartsOn = newValue;
    this.saveFilter();
  }

  showTooltip(event: MouseEvent, data: any): void {
    this.closeTooltip();
  
    const positionStrategy = this.overlayPositionBuilder
      .flexibleConnectedTo({ x: event.clientX, y: event.clientY })
      .withPositions([
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
          offsetY: 10
        }
      ]);
  
    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: false,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      panelClass: 'custom-tooltip-overlay'
    });
  
    const tooltipPortal = new TemplatePortal(
      this.customEventTooltip,
      this.vcr,
      { event: data }
    );
  
    this.overlayRef.attach(tooltipPortal);
  }

  closeTooltip(): void {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  getJoinedValues(values: any[]): string {
    return Array.isArray(values) ? values.map(x => x === null ? 'N/A' : x).join(', ') : values;
  }
}
